// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d2d29810","418":"43a0491a","523":"a48a6431","591":"8c543ad9","623":"aee55913","709":"e6d8cf7d","731":"8d532096","777":"ae80aa3d","899":"1ca63c8d","927":"278c13a9","949":"9a4140b5"}[chunkId] + ".chunk.js";
};